module.exports = __webpack_public_path__ + "static/img/101864.b7bed311.png";